{
  "hr-HR": {
    "model": {
      "profile": {
        "id": "ID korisnika",
        "userName": "Korisničko ime",
        "email": "Adresa e-pošte",
        "emailConfirmed": "Potvrđena adresa e-pošte",
        "phoneNumber": "Broj telefona",
        "phoneNumberConfirmed": "Broj telefona potvrđen.",
        "twoFactorEnabled": "Omogućena dvofaktorska autentifikacija.",
        "lockoutEnd": "Kraj blokade",
        "lockoutEnabled": "Omogućena funkcija zaključavanja.",
        "accessFailedCount": "Broj neuspjelih pokušaja pristupa",
        "firstName": "Ime",
        "lastName": "Prezime",
        "picture": "Slika profila",
        "organisationName": "Organizacija",
        "name": "Ime",
        "roles": "Uloge"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Potvrđeno"
      },
      "action": {
        "resetPassword.tooltip": "Pošaljite upute za resetiranje lozinke korisniku putem e-pošte."
      },
      "message": {
        "resetPassword.success": "Korisniku je poslan e-mail s uputama za resetiranje lozinke."
      }
    }
  }
}